import { render } from "./AccountVerified.vue?vue&type=template&id=5d3dcaaf"
import script from "./AccountVerified.vue?vue&type=script&lang=js"
export * from "./AccountVerified.vue?vue&type=script&lang=js"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__